import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';
import { FaLaptopCode, FaUsers, FaTasks, FaChartLine } from 'react-icons/fa';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const steps = [
    {
        title: 'Sign Up & Create Profile',
        description: 'Register on JectHub and create your professional profile to showcase your skills and interests.',
        icon: <FaUsers size={48} style={{ color: '#fa8c16' }} />,
    },
    {
        title: 'Learn & Participate',
        description: 'Access AI, Machine Learning, and Cybersecurity courses, participate in challenges, and work on real-world projects.',
        icon: <FaLaptopCode size={48} style={{ color: '#13c2c2' }} />,
    },
    {
        title: 'Collaborate & Get Mentorship',
        description: 'Engage with experts, collaborate with peers, and receive mentorship from industry professionals.',
        icon: <FaTasks size={48} style={{ color: '#fa8c16' }} />,
    },
    {
        title: 'Get Certified & Hired',
        description: 'Earn certifications and connect with top companies for job and internship opportunities.',
        icon: <FaChartLine size={48} style={{ color: '#13c2c2' }} />,
    },
];

function HowJectHubWorks() {
    return (
        <Layout>
            <Content style={{ padding: '60px', background: 'linear-gradient(135deg, #e6fffb, #fff7e6)', minHeight: '100vh' }}>
                <Title level={2} style={{ fontSize: '20px', color: '#13c2c2', textAlign: 'center', fontWeight: '700', marginBottom: '20px' }}>
                    How JectHub Works
                </Title>
                <Paragraph style={{ fontSize: '16px', color: '#595959', textAlign: 'center', marginBottom: '48px', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto', lineHeight: '1.6' }}>
                    JectHub is your gateway to bridging the AI skill gap. Dive into hands-on learning, expert mentorship, and exciting job opportunities—all designed to empower students and professionals like you!
                </Paragraph>
                <Row gutter={[24, 24]} justify="center">
                    {steps.map((step, index) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                            <Card
                                hoverable
                                style={{
                                    borderRadius: '16px',
                                    overflow: 'hidden',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                    background: 'linear-gradient(135deg, #ffffff, #f0fafa)',
                                    padding: '24px',
                                    textAlign: 'center',
                                    height: '320px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-10px)';
                                    e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.background = 'linear-gradient(135deg, #f0fafa, #e6fffb)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
                                    e.currentTarget.style.background = 'linear-gradient(135deg, #ffffff, #f0fafa)';
                                }}
                            >
                                <div style={{ marginBottom: '20px' }}>
                                    {step.icon}
                                </div>
                                <Title level={4} style={{ color: '#1a1a1a', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                                    {step.title}
                                </Title>
                                <Paragraph style={{ color: '#595959', fontSize: '14px', lineHeight: '1.5' }}>
                                    {step.description}
                                </Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* Custom CSS */}
                <style jsx global>{`
                    .ant-card {
                        animation: fadeIn 0.5s ease-in-out;
                    }
                    @keyframes fadeIn {
                        0% { opacity: 0; transform: translateY(15px); }
                        100% { opacity: 1; transform: translateY(0); }
                    }
                `}</style>
            </Content>
        </Layout>
    );
}

export default HowJectHubWorks;